var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTrash = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.2,
    height: 18,
    viewBox: "0 0 16.2 18",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{opacity:.7}\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "trash",
    d: "M5.4 1.8V.9a.9.9 0 0 1 .9-.9h3.6a.9.9 0 0 1 .9.9v.9h3.6a1.8 1.8 0 0 1 1.8 1.8v.9a1.8 1.8 0 0 1-1.8 1.8h-.12l-.612 9.18A2.7 2.7 0 0 1 10.975 18H5.243a2.7 2.7 0 0 1-2.693-2.516L1.923 6.3H1.8A1.8 1.8 0 0 1 0 4.5v-.9a1.8 1.8 0 0 1 1.8-1.8zm9 1.8H1.8v.9h12.6zM3.727 6.3l.618 9.061a.9.9 0 0 0 .9.839h5.731a.9.9 0 0 0 .9-.841l.6-9.059H3.728zm2.573.9a.9.9 0 0 1 .9.9v6.3a.9.9 0 0 1-1.8 0V8.1a.9.9 0 0 1 .9-.9zm3.6 0a.9.9 0 0 1 .9.9v6.3a.9.9 0 1 1-1.8 0V8.1a.9.9 0 0 1 .9-.9z",
    className: "cls-1"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTrash);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/trash.468c334f8a2990a08bcdd5310d2861a2.svg";